import { __extends } from "tslib";
import React from 'react';
import { utils } from '../utils';
var MobileZoomImage = /** @class */ (function (_super) {
    __extends(MobileZoomImage, _super);
    function MobileZoomImage(props) {
        return _super.call(this, props) || this;
    }
    MobileZoomImage.prototype.getResizedImage = function (styles) {
        return (React.createElement("img", { className: "preload-zoom-image", src: this.props.resizedUrl[this.props.resizedUrl.length - 1].url, style: styles }));
    };
    MobileZoomImage.prototype.render = function () {
        var _a = this.props, item = _a.item, currentWindow = _a.currentWindow;
        var width = item.width, height = item.height;
        var isLandscape = window.innerWidth > window.innerHeight;
        var screenHeight = window.screen.height;
        var screenWidth = window.screen.width;
        var ratio = screenWidth / screenHeight;
        var cutByHeight = ratio > item.ratio;
        if (isLandscape && utils.isiOS()) {
            cutByHeight = !cutByHeight;
        }
        var scale = cutByHeight
            ? currentWindow.height / height
            : currentWindow.width / width;
        var imageStyles = {
            width: width,
            height: height,
            transform: "translate3d(-50%, -50%, 0) scale(".concat(scale, ")"),
            position: 'absolute',
            left: '50%',
            top: '50%',
        };
        return (React.createElement("div", null,
            this.getResizedImage(imageStyles),
            React.createElement("img", { className: "high-res-zoom-image", key: "idx", src: item.createUrl('full', 'img'), style: imageStyles })));
    };
    return MobileZoomImage;
}(React.Component));
export default MobileZoomImage;
//# sourceMappingURL=mobileZoomImage.js.map